export default "__VITE_ASSET__941ddb41__"